import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import DatasetsDateFilterPicker from './datasets-date-filter-picker'
import DatasetsFilterStep from './datasets-filter-step'
import Dataset from 'scoreboard/datasets/model/dataset'
import DataType from 'scoreboard/datasets/model/data-type'
const { CALENDAR_PERIOD } = DataType

var DatasetsDateFilterStep2 = DatasetsFilterStep.extend({

	className: DatasetsFilterStep.prototype.className + ' datasets-date-filter-step2',

	/**
	 * A dialog which specifies the criteria for complex date filters used in
	 * datasets or when specifying transformations for imports (#13966)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} [options.model]
	 *
	 * @param {String} [options.title] a title to use for the dialog
	 *
	 * @param {Object} options.filter the filter currently being edited
	 *
	 * @param {FilterWizard} [options.wizard] the current wizard, if applicable
	 *
	 * @param {Boolean} [options.new=false] indicates this is a new filter (i.e. not
	 * editing a previously saved filter)
	 *
	 * @param {Boolean} [options.allowIncomplete=false] indicates the "All Time"
	 * option should be available
	 *
	 * @param {Boolean} [options.allowCalculated=true] whether to allow
	 * calculated values
	 *
	 * @param {Boolean} [options.allowAppCalendar=false]
	 */
	initialize: function(options) {
		DatasetsFilterStep.prototype.initialize.apply(this, arguments)

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false,
			allowCleanSubmission: true
		})
	},

	render: function() {
		DatasetsFilterStep.prototype.render.apply(this, arguments)
		this.renderPicker()

		this.formView.start({
			isNew: this.options.new
		})

		this._setupListeners()
		return this
	},

	renderPicker() {
		let allowCalculated = _.get(this.options, 'allowCalculated', true)
		// #46809 only check underlyingField for datasets
		if (this.model instanceof Dataset) {
			let underlyingField = this.model.getUnderlyingField(this.options.filter.fieldId)
			// #46654 don't allow calculations combined with calendar period fields
			allowCalculated = allowCalculated &&
				_.get(underlyingField, 'dataType') != CALENDAR_PERIOD
		}
		this.picker = new DatasetsDateFilterPicker(_.extend({
			formView: this.formView,
			allowCalculated
		}, this.options))

		this.$('.dialog-body-content').append(this.picker.el)
		this.picker.render()
	},

	_setupListeners() {
		this.listenTo(this.picker, 'change', this.formView.change.bind(this.formView))
	},

	saveState: function() {
		if (this.options.wizard) {
			this.options.wizard.options.filter = this.picker.val()
		}
		return this.picker.val()
	},

	remove: function() {
		DatasetsFilterStep.prototype.remove.apply(this, arguments)
		_.invokeMap([this.picker, this.wizardProgress, this.formView], 'remove')
	}
})

export default DatasetsDateFilterStep2

DatasetsDateFilterStep2.__filename__ = 'datasets/filters/datasets-date-filter-step2.js'
